import { ENUM_AdvisorUserPermissionLevel, ENUM_NullableBool } from '@api-new/common';
import { HTTP_AP_ListProperties_ForTable_Request_Sort } from '@api-new/propertyservice';
import { PropertyTableFilterModel } from '@platform/property/pages/property-table/models/property-table-filter.model';
import { PropertyTableRowModel } from '@platform/property/pages/property-table/models/property-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const propertyTableFilterDefaults: PropertyTableFilterModel = {
  propertyAddress: '',
  clientUserDisplayNameOrEmail: '',
  latestZooplaPropertyListingStatuses: [],
  networkIds: [],
  companyIds: [],
  mortgagePartAccountReferenceNumber: '',
  propertyInvestmentType: null,
  isClosed: ENUM_NullableBool.NULLABLE_BOOL_FALSE,
  propertyHasPendingMortgageCompletion: null,
  hasMortgage: null,
};

export const propertyTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
  isPlatformTypeLenderPortal: boolean,
): TableRowDefinitionModel<PropertyTableRowModel, HTTP_AP_ListProperties_ForTable_Request_Sort>[] => [
  {
    columnLabel: 'Address',
    type: RowDefinitionTypeEnum.Address,
    columnKey: 'propertyAddressLines',
    sortKey: 'byAddress',
    width: {
      min: '240px',
      max: '240px',
    },
    isFrozen: true,
  },
  {
    columnLabel: 'Status',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'latestZooplaPropertyListingStatus',
    width: {
      min: '140px',
      max: '140px',
    },
  },
  {
    columnLabel: 'Status Update',
    type: RowDefinitionTypeEnum.DateTimeSince,
    columnKey: 'latestZooplaPropertyListingStatusListedDatetime',
    sortKey: 'byLatestZooplaPropertyListingStatusListedDatetime',
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Investment type',
    type: RowDefinitionTypeEnum.PropertyInvestmentType,
    columnKey: 'propertyInvestmentType',
    width: {
      min: '140px',
      max: '140px',
    },
  },
  {
    columnLabel: 'Client name',
    type: RowDefinitionTypeEnum.Fullname,
    columnKey: 'clientUserDisplayName',
    sortKey: 'byClientUserDisplayName',
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Account number',
    type: RowDefinitionTypeEnum.Text,
    isHidden: !isPlatformTypeLenderPortal,
    columnKey: 'mortgagePartAccountReferenceNumbers',
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Company',
    type: RowDefinitionTypeEnum.Company,
    columnKey: 'companyTradingName',
    sortKey: 'byCompanyName',
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.ClientUserRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_COMPANY,
      },
    ]),
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Equity',
    type: RowDefinitionTypeEnum.Currency,
    columnKey: 'currentEquityValue',
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Equity (%)',
    type: RowDefinitionTypeEnum.Percent,
    columnKey: 'currentEquityPercentage',
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Value',
    type: RowDefinitionTypeEnum.Currency,
    columnKey: 'propertyCurrentPropertyValue',
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'EPC',
    type: RowDefinitionTypeEnum.Number,
    columnKey: 'energyRatingCurrent',
    width: {
      min: '60px',
      max: '60px',
    },
  },
  {
    columnLabel: 'Flags',
    type: RowDefinitionTypeEnum.Image,
    columnKey: 'flags',
    width: {
      min: '120px',
      max: '120px',
    },
  },
];
